import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle
} from "@angular/material/card";
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from "@ngx-translate/core";
import {DataEntity} from "octopus-connect";

@Component({
    selector: 'app-first-time-user-experience-step-two',
    imports: [
        MatIconModule,
        MatProgressSpinnerModule,
        TranslateModule
    ],
    templateUrl: './first-time-user-experience-step-two.component.html',
    styleUrl: './first-time-user-experience-step-two.component.scss'
})
export class FirstTimeUserExperienceStepTwoComponent implements OnInit {
    @Output() nextEmitter: EventEmitter<string> = new EventEmitter();
    @Input() groups: DataEntity[];
    @Input() educationalLevelStarter: DataEntity;
    group: DataEntity;
    ngOnInit() {
        this.group = this.groups.find((g: DataEntity) => g.get('level') === this.educationalLevelStarter.get('label'));
    }

    onNext(mode: string) {
        this.nextEmitter.emit(mode);
    }
}
